const enServiceProviders = {
  serviceProviders: {
    title: 'Service Providers',
    single: 'Service Provider',
    action: {
      create: 'Create service provider',
      edit: 'Update service provider',
      delete: 'Delete service provider',
      save: 'Save service provider',
      cancel: 'Cancel',
      link: 'Associate client',
      unlink: 'Remove client association',
    },
    noData: 'No results. Search by the name or document of the service provider',
    success: {
      create: 'Service provider created successfully',
      update: 'Service provider updated successfully',
      delete: 'Service provider deleted successfully',
      linked: 'Service provider linked successfully',
      unlinked: 'Service provider unlinked successfully',
    },
  },
}

export default enServiceProviders
